import api from '../lib/axios';
import { AxiosError } from 'axios';
import { logger } from '../utils/logger';
import type { WalletBalanceResponse } from '../types/wallet';

const API_ENDPOINTS = {
  BALANCE: '/api/v1/wallet/partner/balance',
  TRANSACTIONS: '/api/v1/wallet/partner/transactions',
};

export const walletService = {
  getWalletBalance: async (): Promise<WalletBalanceResponse> => {
    try {
      const response = await api.get<WalletBalanceResponse>(API_ENDPOINTS.BALANCE);
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<{ error?: string }>;
      logger.error('Get wallet balance error:', axiosError);
      throw error;
    }
  },

  getWalletTransactions: async (
    limit: number = 50,
    role?: 'user' | 'merchant',
  ): Promise<import('../types/wallet').WalletTransactionsResponse> => {
    try {
      const response = await api.get<import('../types/wallet').WalletTransactionsResponse>(
        API_ENDPOINTS.TRANSACTIONS,
        {
          params: { limit, role },
        },
      );
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<{ error?: string }>;
      logger.error('Get wallet transactions error:', axiosError);
      throw error;
    }
  },
};
